var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TiiaForm',{attrs:{"data":_vm.data,"rules":_vm.rules}})}
var staticRenderFns = []

export { render, staticRenderFns }